import React from 'react';
import GoSafeCard from '../../../../stories/components/hotels/common/GoSafeCard/GoSafeCardComponent';
import {safetyHeaderDataSelectorFn} from '@stencil/hotels-smartengage-store';
import {useSelector} from 'react-redux';
import GoSafeInfoLoader from '../../../../stories/components/hotels/Loadingpage/GoSafeInfoLoader/GoSafeInfoLoader';

const GoSafeCardBlock: React.FC<{ContainerWrapper?: Element}> = ({ContainerWrapper}) => {
  const {headerData, isLoading} = useSelector(safetyHeaderDataSelectorFn);

  if (!isLoading && !headerData) return null;

  if (isLoading || !headerData)
    return ContainerWrapper ? (
      <ContainerWrapper>
        <GoSafeInfoLoader />
      </ContainerWrapper>
    ) : (
      <GoSafeInfoLoader />
    );

  // if (!headerData) return null;

  const {banner_content = {}, cta_url: ctaUrl = ''} = headerData;
  const {
    title,
    title_color: titleColor,
    message,
    txt_color: messageColor,
    txt_bg_color: backgroundColor = '',
    footer: footerText,
    footer_color: footerColor,
    icon,
  } = banner_content;

  const transformedData = {
    title,
    titleColor,
    message,
    messageColor,
    footerText,
    footerColor,
    icon,
    ctaUrl,
    backgroundColor,
  };

  return <GoSafeCard {...transformedData} ContainerWrapper={ContainerWrapper} />;
};

export default GoSafeCardBlock;
